import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSuppressEmbeddedChatWidget } from '@mm/state/selectors/viewSelectors';
import { EmbeddedChatWidget } from './EmbeddedChatWidget';

export const VariableChatWidget = () => {
  const suppressEmbeddedChatWidget = useSelector(
    selectSuppressEmbeddedChatWidget,
  );

  // Don't show chat widget until 2.5sec after app is loaded
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setTimeout(() => setReady(true), 2500);
  }, []);

  if (!ready || suppressEmbeddedChatWidget) {
    return null;
  }

  return <EmbeddedChatWidget />;
};
